import React from 'react';
import'./confirm.css'
const Confirm = ({isOpen,setIsOpen,SendTest}) => {
    return (
        <div className={isOpen? 'modalStyle':'modalOff'}>
            <div className={'modalStyle__content'}>
                <h1 className={'modalQuestionText'}>Хотите завершить тест?</h1>
                <h4 className={'modalQuestionDescription'}>После завершения теста, тест становится недоступным!</h4>
                <div className={'modalButtonDiv'}>
                    <button onClick={e=>{SendTest(); setIsOpen(false)}} className={'modalButton'}>Да</button>
                    <button onClick={e=>{setIsOpen(false)}} className={'modalButton'}>Нет</button>
                </div>
            </div>
        </div>
    );
};

export default Confirm;